import React from 'react';
import { Outlet } from 'react-router-dom';

const ImagesPage = () => <Outlet />;

export default ImagesPage;
